"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CustomPopupPageSizeChart = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomPopupPageSizeChart, _HTMLElement);
  function CustomPopupPageSizeChart() {
    _classCallCheck(this, CustomPopupPageSizeChart);
    return _callSuper(this, CustomPopupPageSizeChart);
  }
  _createClass(CustomPopupPageSizeChart, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.rootId = "popup-size-chart";
      this.closeButton = this.querySelector(".close");
      this.pageContent = this.querySelector(".page-content");
      this.popupContent = this.querySelector(".custom-popup-page");
      if (!document.getElementById(this.rootId)) {
        this.closeButton.addEventListener("click", this.close.bind(this));
      }
      var self = this;
      this.addEventListener("click", function(e) {
        if (self.popupContent && !self.popupContent.contains(e.target)) {
          self.close();
        }
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
    }
  }, {
    key: "adoptedCallback",
    value: function adoptedCallback() {
    }
  }, {
    key: "show",
    value: function show() {
      var _this = this;
      this.renderContent();
      var mainProductContent = document.querySelector(".main-product-content");
      if (mainProductContent) mainProductContent.style.zIndex = 100;
      this.style.display = "flex";
      document.body.classList.add("overflow-hidden");
      document.getElementById(this.rootId).style.display = "block";
      this.classList.add("active");
      this.popupContent.style.transform = "translateX(120%)";
      var transitionend = function transitionend() {
        _this.popupContent.removeEventListener("transitionend", transitionend);
        _this.popupContent.style.transform = "translateX(0)";
      };
      setTimeout(function () {
        _this.popupContent.style.transform = "translateX(0)";
      }, 0);
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;
      this.popupContent.style.transform = "translateX(120%)";
      var transitionend = function transitionend() {
        _this2.popupContent.removeEventListener("transitionend", transitionend);
        _this2.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        var stickyHeader = document.querySelector(".shopify-section-header-sticky");
        if (stickyHeader) stickyHeader.style.zIndex = 3;
        _this2.style.display = "none";
        var mainProductContent = document.querySelector(".main-product-content");
        if (mainProductContent) mainProductContent.style.zIndex = 1;
        document.body.classList.remove("overflow-hidden");
        document.getElementById(_this2.rootId).style.display = "none";
      };
      this.popupContent.addEventListener("transitionend", transitionend);
    }
  }, {
    key: "moveRoot",
    value: function moveRoot() {
      var teleport = document.createElement("div");
      teleport.style.zIndex = "1000";
      teleport.style.position = "fixed";
      teleport.style.top = "0";
      teleport.style.left = "0";
      teleport.style.width = "100vw";
      teleport.style.height = "100vh";
      teleport.setAttribute("id", this.rootId);
      document.body.append(teleport);
      var sizeChart = document.querySelector("#product-size-guide-page");
      teleport.appendChild(sizeChart);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      if (!this.classList.contains("rendered")) {
        this.classList.add("rendered");
      } else {
        return;
      }
      var html = this.querySelector("#product-size-guide").content.cloneNode(true);
      this.html = html;
      var content = html.querySelector(".size-content").cloneNode(true);
      var style = html.querySelector("style").cloneNode(true);
      var script = html.querySelector("script").cloneNode(true);
      this.pageContent.appendChild(style);
      this.pageContent.appendChild(content);
      this.appendChild(script);
      this.moveRoot();
    }
  }]);
  return CustomPopupPageSizeChart;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get("custom-popup-page-size-chart")) {
  customElements.define("custom-popup-page-size-chart", CustomPopupPageSizeChart);
}